import { render, staticRenderFns } from "./TavernModalWrapper.vue?vue&type=template&id=db664b5c&scoped=true&"
import script from "./TavernModalWrapper.ts?vue&type=script&lang=ts&"
export * from "./TavernModalWrapper.ts?vue&type=script&lang=ts&"
import style0 from "./TavernModalWrapper.vue?vue&type=style&index=0&id=db664b5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db664b5c",
  null
  
)

export default component.exports